import { render, staticRenderFns } from "./ConnyProfileModal.vue?vue&type=template&id=36b2971c&scoped=true&"
import script from "./ConnyProfileModal.vue?vue&type=script&lang=js&"
export * from "./ConnyProfileModal.vue?vue&type=script&lang=js&"
import style0 from "./ConnyProfileModal.vue?vue&type=style&index=0&id=36b2971c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b2971c",
  null
  
)

export default component.exports